module.exports = __webpack_public_path__ + "img/Larsen-&-Toubro.5740ec2b.jpg";